(function () {
  var dataSelector = '[data-variant-stock-messages]';
  var badgeSelector = '[data-stock-message-badge]';
  var swatchSelector = '.swatch[data-stock-message-option]';
  var eventSelector = '.cust_swatch_element, .swatch_opt, .single-option-selector, select[name="id"], input[name="id"]';

  function matches(element, selector) {
    if (!element || element === document || element === window) {
      return false;
    }

    var proto = Element.prototype;
    var matcher = proto.matches || proto.msMatchesSelector || proto.webkitMatchesSelector;
    return matcher.call(element, selector);
  }

  function closest(element, selector) {
    while (element && element !== document) {
      if (matches(element, selector)) {
        return element;
      }

      element = element.parentElement;
    }

    return null;
  }

  function getVariantStockScope(element) {
    var scope = closest(element, 'form');

    if (!scope || !scope.querySelector(dataSelector)) {
      scope = closest(element, '.product-template__container, [data-section-type="product"], .product, .product-template, .quickview-tpl, .product-item, [data-product-id], [data-product]');
    }

    return scope || document;
  }

  function getVariantStockMessages(scope) {
    var dataElement = scope.querySelector(dataSelector);

    if (!dataElement) {
      return [];
    }

    if (dataElement.__variantStockMessages) {
      return dataElement.__variantStockMessages;
    }

    try {
      dataElement.__variantStockMessages = JSON.parse((dataElement.textContent || '').trim());
    } catch (error) {
      dataElement.__variantStockMessages = [];
    }

    return dataElement.__variantStockMessages;
  }

  function getVariantStockMessageAssets(scope) {
    var dataElement = scope.querySelector('[data-variant-stock-message-assets]');

    if (!dataElement) {
      return {};
    }

    if (dataElement.__variantStockMessageAssets) {
      return dataElement.__variantStockMessageAssets;
    }

    try {
      dataElement.__variantStockMessageAssets = JSON.parse((dataElement.textContent || '').trim());
    } catch (error) {
      dataElement.__variantStockMessageAssets = {};
    }

    return dataElement.__variantStockMessageAssets;
  }

  function getSelectedVariant(scope, variants) {
    var idInput = scope.querySelector('#product-selectors, select[name="id"], input[name="id"]');
    var selectedId = idInput && idInput.value;

    if (!selectedId) {
      return variants.length === 1 ? variants[0] : null;
    }

    selectedId = String(selectedId);

    for (var index = 0; index < variants.length; index++) {
      if (String(variants[index].id) === selectedId) {
        return variants[index];
      }
    }

    return variants.length === 1 ? variants[0] : null;
  }

  function getSelectedOptions(scope, variants, optionCount) {
    var selectedOptions = [];
    var selectedVariant = getSelectedVariant(scope, variants);
    var swatches = scope.querySelectorAll('.swatch[data-option-index]');
    var selectors = scope.querySelectorAll('.single-option-selector');

    if (selectedVariant && selectedVariant.options) {
      selectedOptions = selectedVariant.options.slice(0);
    }

    Array.prototype.forEach.call(swatches, function (swatch) {
      var optionIndex = parseInt(swatch.getAttribute('data-option-index'), 10);
      var checkedInput = swatch.querySelector('input.swatch_opt:checked, input[type="radio"]:checked');

      if (!isNaN(optionIndex) && checkedInput) {
        selectedOptions[optionIndex] = checkedInput.value || checkedInput.getAttribute('value') || '';
      }
    });

    Array.prototype.forEach.call(selectors, function (selector, selectorIndex) {
      var indexValue = selector.getAttribute('data-option-index') || selector.getAttribute('data-index') || '';
      var namedIndex = /^option(\d+)$/.exec(indexValue);
      var optionIndex = namedIndex ? parseInt(namedIndex[1], 10) - 1 : parseInt(indexValue, 10);

      if (isNaN(optionIndex)) {
        optionIndex = selectorIndex;
      }

      if (!isNaN(optionIndex) && selector.value) {
        selectedOptions[optionIndex] = selector.value;
      }
    });

    for (var index = 0; index < optionCount; index++) {
      if (typeof selectedOptions[index] === 'undefined') {
        selectedOptions[index] = '';
      }
    }

    return selectedOptions;
  }

  function findVariantByOptions(variants, options) {
    for (var variantIndex = 0; variantIndex < variants.length; variantIndex++) {
      var variantOptions = variants[variantIndex].options || [];
      var matched = true;

      for (var optionIndex = 0; optionIndex < options.length; optionIndex++) {
        if (!options[optionIndex] || variantOptions[optionIndex] !== options[optionIndex]) {
          matched = false;
          break;
        }
      }

      if (matched) {
        return variants[variantIndex];
      }
    }

    return null;
  }

  function normalizeVariantStockMessage(message) {
    var text = message == null ? '' : String(message).trim();
    if (text.toLowerCase() === 'true') return '48hrs';
    if (text.toLowerCase() === 'false') return '';
    return text;
  }

  function normalizeVariantStockMessageKey(message) {
    return String(message || '').toLowerCase().replace(/[\s_-]+/g, '');
  }

  function getVariantStockMessageImage(message, assets) {
    var key = normalizeVariantStockMessageKey(message);

    if ((key === '48hrs' || key === '48hr' || key === '48h') && assets['48hrs']) {
      return { src: assets['48hrs'], className: 'variant-stock-badge--48hrs' };
    }

    if (key === 'uswarehouse' && assets.uswarehouse) {
      return { src: assets.uswarehouse, className: 'variant-stock-badge--us-warehouse' };
    }

    return null;
  }

  function renderVariantStockBadge(badge, stockMessage, assets) {
    var image = getVariantStockMessageImage(stockMessage, assets);

    badge.textContent = '';
    badge.title = stockMessage;
    badge.classList.remove(
      'variant-stock-badge--image',
      'variant-stock-badge--48hrs',
      'variant-stock-badge--us-warehouse'
    );

    if (image) {
      var imageElement = document.createElement('img');
      imageElement.src = image.src;
      imageElement.alt = stockMessage;
      imageElement.draggable = false;
      badge.appendChild(imageElement);
      badge.classList.add('variant-stock-badge--image', image.className);
      badge.hidden = false;
      return;
    }

    if (stockMessage) {
      badge.textContent = stockMessage;
      badge.hidden = false;
    } else {
      badge.hidden = true;
    }
  }

  function getOptionCount(variants) {
    var optionCount = 0;

    variants.forEach(function (variant) {
      optionCount = Math.max(optionCount, (variant.options || []).length);
    });

    return optionCount;
  }

  function refreshShippingTime(scope, selectedVariant) {
    var productScope = closest(scope, '[data-section-type="product"], .product-template__container') || scope;
    var message = normalizeVariantStockMessage(selectedVariant && selectedVariant.message);
    var key = normalizeVariantStockMessageKey(message);
    var shipsIn48Hours = Boolean(selectedVariant && selectedVariant.available &&
      (key === '48hrs' || key === '48hr' || key === '48h'));

    Array.prototype.forEach.call(productScope.querySelectorAll('.prod-info-time'), function (container) {
      if (!container.querySelector('.pointer2')) return;

      // Only toggle the two processing-time alternatives; keep shipping details and plus signs intact.
      Array.prototype.forEach.call(container.children, function (child) {
        if (matches(child, '.pointer2')) {
          child.style.display = shipsIn48Hours ? '' : 'none';
        } else if (matches(child, '.pointer')) {
          child.style.display = shipsIn48Hours ? 'none' : '';
        }
      });
    });
  }

  function refreshVariantStockBadges(scope) {
    if (!scope || !scope.querySelector) {
      scope = getVariantStockScope(scope || document.body);
    }

    var variants = getVariantStockMessages(scope);

    if (!variants.length) {
      return;
    }

    var selectedOptions = getSelectedOptions(scope, variants, getOptionCount(variants));
    var selectedVariant = findVariantByOptions(variants, selectedOptions);
    var assets = getVariantStockMessageAssets(scope);
    var targetSwatches = scope.querySelectorAll(swatchSelector);

    refreshShippingTime(scope, selectedVariant);

    Array.prototype.forEach.call(scope.querySelectorAll('[data-stock-message-single]'), function (container) {
      var message = normalizeVariantStockMessage(selectedVariant && selectedVariant.message);
      var badge = container.querySelector(badgeSelector);
      if (badge) renderVariantStockBadge(badge, message, assets);
      container.hidden = targetSwatches.length > 0 || !message;
    });

    Array.prototype.forEach.call(targetSwatches, function (swatch) {
      var optionIndex = parseInt(swatch.getAttribute('data-option-index'), 10);

      if (isNaN(optionIndex)) {
        return;
      }

      Array.prototype.forEach.call(swatch.querySelectorAll('.swatch-element'), function (element) {
        var badge = element.querySelector(badgeSelector);
        var optionValue = element.getAttribute('data-value');
        var badgeOptions = selectedOptions.slice(0);
        var stockVariant;
        var stockMessage = '';

        if (!badge || optionValue === null) {
          return;
        }

        badgeOptions[optionIndex] = optionValue;
        stockVariant = findVariantByOptions(variants, badgeOptions);
        stockMessage = normalizeVariantStockMessage(stockVariant && stockVariant.message);

        renderVariantStockBadge(badge, stockMessage, assets);
        element.classList.toggle('has-stock-message-badge', Boolean(stockMessage));
      });
    });
  }

  function refreshAllVariantStockBadges() {
    Array.prototype.forEach.call(document.querySelectorAll(dataSelector), function (dataElement) {
      refreshVariantStockBadges(getVariantStockScope(dataElement));
    });
  }

  function handleVariantChange(event) {
    if (!matches(event.target, eventSelector) && !closest(event.target, eventSelector)) {
      return;
    }

    var scope = getVariantStockScope(event.target);

    window.setTimeout(function () {
      refreshVariantStockBadges(scope);
    }, 0);

    window.setTimeout(function () {
      refreshVariantStockBadges(scope);
    }, 80);
  }

  document.addEventListener('click', handleVariantChange, false);
  document.addEventListener('change', handleVariantChange, false);
  document.addEventListener('DOMContentLoaded', refreshAllVariantStockBadges, false);
  document.addEventListener('shopify:section:load', refreshAllVariantStockBadges, false);

  // This theme emits variantChange through jQuery, including programmatic changes.
  if (window.jQuery) {
    window.jQuery(document).on('variantChange.stockMessageBadge', '[data-section-type="product"]', function () {
      window.setTimeout(refreshAllVariantStockBadges, 0);
    });
  }
  window.addEventListener('load', refreshAllVariantStockBadges, false);
  if (document.readyState !== 'loading') refreshAllVariantStockBadges();
  window.setTimeout(refreshAllVariantStockBadges, 300);

  window.refreshVariantStockBadges = refreshAllVariantStockBadges;
})();
